import './app.scss';
import domready from 'domready';
import 'lazysizes';
import { getOffset, smoothScrollTo } from './utilities/js/helper';
import { loadLazyImages } from './utilities/js/lazy-image-loader';
import { EventScroller } from './utilities/js/event-scroller';
import { MediaMatchHandler } from './utilities/js/media-match-handler';
import { ResizeHandler } from './utilities/js/resize-handler';
import Siteheader from './layout/siteheader/siteheader';

// GLOBAL OPTIONS
window.eventScroller = new EventScroller();
window.mediaMatchHandler = new MediaMatchHandler();
window.resizeHandler = new ResizeHandler();

window.youtubeApi = false;
window.youtubeApiLoading = false;
window.locale = document.querySelector('html').getAttribute('lang');
window.siteheaderAPI = null;
window.checkForScroll = true;

// GLOBAL OPTIONS
window.OPTIONS = { // eslint-disable-line
    loader: '<span class="loading"><span class="loader"><span class="plane"></span></span></span>'
};

const browserCheck = () => {
    window.browser = {
        csshover: !window.matchMedia('(pointer:coarse)').matches,
        ios: (/iPhone|iPad|iPod/i).test(navigator.userAgent),
        iphone: (/iPhone|iPod/i).test(navigator.userAgent),
        android: (/(android)/i).test(navigator.userAgent),
        firefox: (/firefox/i).test(navigator.userAgent),
        safari: (/Version\/[\d.]+.*Safari/).test(navigator.userAgent)
    };

    Object.entries(window.browser).forEach(([key, value]) => {
        document.documentElement.classList.add((!value) ? `no-${key}` : `${key}`);
    });
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
};

window.checkInView = (entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            if (!entry.target.classList.contains('inview')) {
                entry.target.classList.add('inview');

                if (typeof entry.target.dataset.footer === 'undefined') {
                    window.inViewObserver.unobserve(entry.target);
                }
            }
        }
    });
};

window.inViewObserver = new IntersectionObserver(window.checkInView, {
    threshold: 0.1
});

const initDataForCheckbox = ($content) => {
    const $$checkboxTrigger = $content.querySelectorAll('[data-for-checkbox]');

    if ($$checkboxTrigger.length > 0) {
        const resetAllTriggersByReference = (reference, state) => {
            const $allReferenceCheckboxes = $content.querySelectorAll(`[data-for-checkbox="${reference}"]`);

            if ($allReferenceCheckboxes.length > 0) {
                $allReferenceCheckboxes.forEach($checkboxTrigger => {
                    let triggerActiveAttribute = 'aria-pressed';

                    if ($checkboxTrigger.dataset.activeAttribute !== undefined) {
                        triggerActiveAttribute = $checkboxTrigger.dataset.activeAttribute;
                    }

                    $checkboxTrigger.setAttribute(triggerActiveAttribute, state);
                });
            }
        };

        $$checkboxTrigger.forEach($checkboxTrigger => {
            const checkboxReference = $checkboxTrigger.dataset.forCheckbox;
            let triggerActiveAttribute = 'aria-pressed';

            if ($checkboxTrigger.dataset.activeAttribute !== undefined) {
                triggerActiveAttribute = $checkboxTrigger.dataset.activeAttribute;
            }

            const $checkbox = $content.querySelector(`#${checkboxReference}`);

            $checkboxTrigger.onclick = () => {
                if ($checkbox.checked === true) {
                    $checkbox.checked = false;
                    resetAllTriggersByReference(checkboxReference, false);
                } else {
                    $checkbox.checked = true;
                    $checkboxTrigger.setAttribute(triggerActiveAttribute, $checkbox.checked);
                }
            };

            if ($checkbox) {
                $checkbox.onchange = () => {
                    $checkboxTrigger.setAttribute(triggerActiveAttribute, $checkbox.checked);
                };
            }
        });
    }
};

const initServiceBanner = ($content) => {
    const $serviceBanner = $content.querySelector('[data-service-banner="root"]');

    if ($serviceBanner) {
        loadServiceBanner($serviceBanner.dataset.serviceBannerRoute, $serviceBanner);
    }
};

const loadServiceBanner = (fetchRoute, $loadContainer) => {
    fetch(fetchRoute, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
        .then(response => {
            if (!response.ok && response.status !== 422) {
                throw new Error(`HTTP ERROR: ${response.status}`);
            }
            return response.text();
        })
        .then(data => {
            if (data) {
                $loadContainer.innerHTML = data;
            }
        })
        .catch(error => console.error("ERROR:", error));
};

const initContent = ($content) => {
    console.log('start app');
    initDataForCheckbox($content);
    initServiceBanner($content);

    const $$anchor = $content.querySelectorAll('a[href*="#"]:not([data-anchor-navigation])');
    for (let i = 0; i < $$anchor.length; i++) {
        const $anchor = $$anchor[i];
        let anchorTimeout = null;

        $anchor.addEventListener('click', (e) => {
            let baseUrl = $anchor.getAttribute('href').split('#')[0];
            const targetId = $anchor.getAttribute('href').split('#')[1];
            const $target = document.getElementById(targetId);
            const currentUrl = window.location.href;
            let focusTimer = null;

            if (baseUrl === '') {
                baseUrl = currentUrl;
            }

            if (baseUrl === currentUrl && $target !== null) {
                const anchorDimensions = getOffset($target);
                const anchorDimensionsTop = anchorDimensions.top;

                smoothScrollTo(0, anchorDimensionsTop, window.OPTIONS.speed);

                $target.setAttribute('tabindex', 0);
                $target.focus();

                focusTimer = setTimeout(() => {
                    $target.removeAttribute('tabindex');
                    clearTimeout(focusTimer);
                }, 200);

                if (window.location.hash && window.siteheaderAPI) {
                    clearTimeout(anchorTimeout);
                    anchorTimeout = window.setTimeout(() => {
                        window.siteheaderAPI.toggleHeader(false);
                    }, 500);
                }
                e.preventDefault();
            }
        });

        if (window.location.hash && window.siteheaderAPI) {
            clearTimeout(anchorTimeout);
            anchorTimeout = window.setTimeout(() => {
                window.siteheaderAPI.toggleHeader(false);
            }, 500);
        }
    }

    loadLazyImages();
};

domready(function () {
    const initApplication = () => {
        browserCheck();

        window.eventScroller.init();
        window.resizeHandler.init();

        window.dataInview = document.querySelectorAll('[data-inview]:not(.inview)');
        setTimeout(() => {
            window.dataInview.forEach((dataInView) => {
                window.inViewObserver.observe(dataInView);
            });
        }, 500);

        const $siteheader = document.querySelector('[data-siteheader="root"]');
        if ($siteheader) {
            const siteheaderAPI = new Siteheader($siteheader);
            siteheaderAPI.initialize();
            window.siteheaderAPI = siteheaderAPI;
        }

        const contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: document
            }
        });

        window.dispatchEvent(contentUpdateEvent);

        document.body.classList.add('page--loaded');
        window.addEventListener('beforeunload', () => {
            const isMailTo = document.activeElement.protocol === 'mailto:';
            const isTel = document.activeElement.protocol === 'tel:';

            if (!(isMailTo && isTel)) {
                document.body.classList.remove('page--loaded');
            }
        });

        window.addEventListener('pageshow', (event) => {
            const historyTraversal = event.persisted || (typeof window.performance !== 'undefined' && window.performance.navigation.type === 2);
            if (historyTraversal) {
                window.location.reload();
            }
        });

        // jump to main content and set focus on container
        document.querySelector('.hidden-shortcut a[href="#main"]').addEventListener('click', () => {
            document.querySelector('#main').focus();
        });

        initContent(document);
    };

    initApplication();
});
